import { ref } from 'vue'
import { Room } from 'livekit-client'

const room = new Room()

export const DIABOLOCOM_RTC_CONFIG: RTCConfiguration = {
  iceServers: [
    { urls: 'stun:webrtc-fr01.diabolocom.ai:3478' },
    { urls: 'stun:webrtc-fr02.diabolocom.ai:3478' },
  ],
}
const connected = ref(false)
const currentRoomName = ref<string | null>(null)
const activeSpeakers = ref<string[]>([])
const lastSpeaker = ref<string | null>(null)
const disconnectedRooms = ref<Set<string>>(new Set())
const connectionError = ref(false)

export const useLivekitCore = () => ({
  room,
  connected,
  currentRoomName,
  activeSpeakers,
  lastSpeaker,
  disconnectedRooms,
  connectionError,
})
